import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { PromisePool } from 'es6-promise-pool';
import _ from 'lodash';
import flow from 'lodash/flow';
import { DropTarget } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';
import { v4 as uuidv4 } from 'uuid';
import { injectIntl } from 'react-intl';
import * as linkify from 'linkifyjs';
import {
  Button,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
  ButtonGroup,
} from 'reactstrap';

import { showModal } from '../../actions';
import { showConfirmationModal } from '../../actions/App';
import { fetchClientUsage } from '../../actions/Clients';
import {
  fetchCollection,
  refreshCollections,
} from '../../actions/Collections';
import {
  hideUploadModal,
  refreshFiles,
  updateFile,
  unsetSelectedFile,
  setFilesParams,
} from '../../actions/Files';

import { APIcreateFolderCollections } from '../../api/Collections';
import {
  APIcreateFile,
  APIdeleteFile,
  APIcreateFilesGroup,
  APIfinishFilesGroup,
  APIgetWebsites,
} from '../../api/Files';
import { APIgetGroups } from '../../api/Group';
import { APIgetUsers } from '../../api/User';

import { sendTrackingEvent } from '../../helpers';
import {
  accountUsageLock,
  subscriptionExpired,
} from '../../helpers/App';
import { userCan } from '../../helpers/Auth';
import { uploadFilesTarget } from '../../helpers/DNDUploadFiles';
import { eventDispatch } from '../../helpers/Events';
import { userHasFeature } from '../../helpers/Features';
import {
  fileHasErrors,
  getFileExtension,
  getFileNameWithoutExtension,
  getFilePrefix,
  getFileSuffix,
  lettersToIndex,
} from '../../helpers/Files';
import { addFlashMessage } from '../../helpers/FlashMessages';
import { getTaxonomyRoleSetting } from '../../helpers/Metadata';
import { getSetting } from '../../helpers/Settings';
import {
  getAccessTypeFromFiles,
  getCollectionsFromFiles,
  fileObject,
} from '../../helpers/Uploader';
import { isValidUrl } from '../../helpers/Validators';
import withUploader from '../../helpers/withUploader';

import UploadFile from './File';
import UploadFileForm from './FileForm';
import UploadFileCollection from './FileCollectionV2';
import UploadFileAccess from './FileAccess';
import UploadFileAccessGroups from './FileAccessGroups';
import UploadFileDate from './FileDate';
import UploadFileExpirationDate from './FileExpirationDate';
import UploadDropOverlay from '../UploadDropOverlay';
import AccessModalAccess from '../Access/ModalAccess';
import FileStatusSelect from './FileStatusSelect';

import ErrorBoundary from '../ErrorBoundary';
import UploadModalTabs from './ModalTabs';
import FileUploadAddPrefixSuffix from './AddPrefixSuffix';
import ProcessingSpinner from '../ProcessingSpinner';

class UploadModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      nestedModal: false,
      closeAll: false,
      saving: false,
      cancelling: false,
      savedFiles: 0,
      cancelledFiles: 0,
      uploadUuid: null,
      mapping: getSetting('use_exif_mapping_by_default') && getSetting('exif_mapping_enabled'),
      selectedGroups: [],
      selectedUsers: [],
      collectionError: false,
      saveAfterUpload: false,
      awaitSaveAfterUpload: false,
      websites: [],
      users: [],
      usersLoading: false,
      groups: [],
      groupsLoading: false,
      timestamp: new Date(),
      uploadedFilesFilter: 'all',
      folderCollections: null,
      activeTab: 'details',
      includePrefix: false,
      prefixLabel: null,
      prefixSeparator: null,
      prefixOffset: '',
      includeSuffix: false,
      suffixLabel: null,
      suffixSeparator: '',
      suffixOffset: '',
      metadataGroup: null,
    };

    this.fileInput = React.createRef();

    this.toggle = this.toggle.bind(this);
    this.toggleNested = this.toggleNested.bind(this);
    this.toggleAll = this.toggleAll.bind(this);
    this.triggerInputFile = this.triggerInputFile.bind(this);
    this.submitFiles = this.submitFiles.bind(this);
    this.toggleSelected = this.toggleSelected.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleTaxonomyChange = this.handleTaxonomyChange.bind(this);
    this.handleMetadataGroupChange = this.handleMetadataGroupChange.bind(this);
    this.handleCollectionChange = this.handleCollectionChange.bind(this);
    this.handleCustomFieldChange = this.handleCustomFieldChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSaveValidate = this.handleSaveValidate.bind(this);
    this.handleSaveFiles = this.handleSaveFiles.bind(this);
    this.handleCancelFiles = this.handleCancelFiles.bind(this);
    this.handleRemoveFile = this.handleRemoveFile.bind(this);
    this.handleMappingSwitch = this.handleMappingSwitch.bind(this);
    this.handleSwitchGroup = this.handleSwitchGroup.bind(this);
    this.handleSwitchUser = this.handleSwitchUser.bind(this);
    this.handleSaveAfterUploadChange = this.handleSaveAfterUploadChange.bind(this);
    this.handleAddUrl = this.handleAddUrl.bind(this);
    this.handleUploadedFilesFilter = this.handleUploadedFilesFilter.bind(this);
    this.handleRetryAllFailed = this.handleRetryAllFailed.bind(this);
    this.handleResetValidation = this.handleResetValidation.bind(this);
    this.handleSwitchTab = this.handleSwitchTab.bind(this);
    this.handleIncludePrefix = this.handleIncludePrefix.bind(this);
    this.handlePrefixLabel = this.handlePrefixLabel.bind(this);
    this.handlePrefixSeparator = this.handlePrefixSeparator.bind(this);
    this.handleIncludeSuffix = this.handleIncludeSuffix.bind(this);
    this.handleSuffixLabel = this.handleSuffixLabel.bind(this);
    this.handleSuffixSeparator = this.handleSuffixSeparator.bind(this);
    this.handleGetFilePrefix = this.handleGetFilePrefix.bind(this);
    this.handleGetFileSuffix = this.handleGetFileSuffix.bind(this);
    this.handleClearPrefixes = this.handleClearPrefixes.bind(this);
    this.handleClearSuffixes = this.handleClearSuffixes.bind(this);
    this.handlePrefixOffset = this.handlePrefixOffset.bind(this);
    this.handleSuffixOffset = this.handleSuffixOffset.bind(this);
    this.getPrefixOffset = this.getPrefixOffset.bind(this);
    this.getSuffixOffset = this.getSuffixOffset.bind(this);
    this.addSelected = this.addSelected.bind(this);
    this.removeSelected = this.removeSelected.bind(this);
    this.addNewGroup = this.addNewGroup.bind(this);
    this.addNewUser = this.addNewUser.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {
      filesModificationTimestamp,
      uploadModal,
      modalMode,
      loadCurrentUsage,
      submittedFiles,
      uploadCompleted,
      metadataGroups,
    } = this.props;
    const {
      uploadedFilesFilter,
      metadataGroup,
    } = this.state;

    if (uploadCompleted !== prevProps.uploadCompleted) {
      this.setState({
        awaitSaveAfterUpload: true,
      });
    }

    if (uploadCompleted) {
      this.handleAutoSave();
    }

    if (prevProps.filesModificationTimestamp !== filesModificationTimestamp) {
      if (userCan('file.upload')) {
        this.submitInitialFiles();
      }
    }

    if (uploadModal && prevProps.uploadModal !== uploadModal) {
      if (modalMode === 'edit' && submittedFiles.length === 0) {
        this.submitSelectedFiles();
      }

      if (modalMode === 'upload') {
        loadCurrentUsage();
        sendTrackingEvent('upload-modal-open');
      }

      if (modalMode === 'link') {
        if (this.isLinkEditMode()) {
          this.submitSelectedFiles();
        } else {
          this.initializeLink();
        }
        this.loadWebsites();
        sendTrackingEvent('link-modal-open');
      }

      this.setState({
        activeTab: 'details',
        includePrefix: false,
        prefixLabel: null,
        prefixSeparator: null,
        prefixOffset: '',
        includeSuffix: false,
        suffixLabel: null,
        suffixSeparator: '',
        suffixOffset: '',
      });

      this.loadGroups();
      this.loadUsers();
      this.setDefaultMappingState();
    }

    if (uploadedFilesFilter === 'failed' && submittedFiles.filter(sf => sf.uploadStatus === 'failed' || fileHasErrors(sf.errors)).length === 0) {
      this.setState({ uploadedFilesFilter: 'all' });
    }

    if (metadataGroups.length > 0 && !metadataGroup) {
      this.setState({
        metadataGroup: {
          value: metadataGroups[0].id,
          name: metadataGroups[0].name,
        },
      });
    }
  }

  getFileStatus(statusId) {
    const { fileStatuses } = this.props;
    return fileStatuses.find(fs => (fs.id === parseInt(statusId))) || { value: -1 };
  }

  getHeaderTitle() {
    const {
      intl,
      modalMode,
      selectedFiles,
    } = this.props;

    if (modalMode === 'upload') {
      return intl.formatMessage({ defaultMessage: 'Upload Files' });
    }
    if (modalMode === 'edit') {
      return intl.formatMessage({ defaultMessage: 'Edit Files' });
    }
    if (modalMode === 'link') {
      if (selectedFiles.length === 0) {
        return intl.formatMessage({ defaultMessage: 'Add Link Cards' });
      }
      return intl.formatMessage({ defaultMessage: 'Edit Link Cards' });
    }

    return '';
  }

  getListTitle() {
    const {
      intl,
      modalMode,
      submittedFiles,
    } = this.props;
    const uploadedFiles = submittedFiles.filter(sf => (sf.uploadStatus === 'completed' && !fileHasErrors(sf.errors)));

    let text = '';
    if (modalMode === 'edit') {
      text = intl.formatMessage({
        defaultMessage: 'Editing {submittedFiles} {submittedFiles, plural, one {file} other {files}}',
      }, {
        submittedFiles: submittedFiles.length,
      });
    }
    if (modalMode === 'link') {
      if (this.isLinkEditMode()) {
        text = intl.formatMessage({
          defaultMessage: 'Editing {submittedFiles} link {submittedFiles, plural, one {card} other {cards}}',
        }, {
          submittedFiles: submittedFiles.length,
        });
      } else {
        text = intl.formatMessage({
          defaultMessage: 'Added {submittedFiles} link {submittedFiles, plural, one {card} other {cards}}',
        }, {
          submittedFiles: submittedFiles.length,
        });
      }
    }
    if (modalMode === 'upload') {
      text = intl.formatMessage({
        defaultMessage: 'Uploaded {uploadedFiles} {uploadedFiles, plural, one {file} other {files}} of {submittedFiles}',
      }, {
        uploadedFiles: uploadedFiles.length,
        submittedFiles: submittedFiles.length,
      });
    }

    return text;
  }

  getWebsite(url) {
    const { websites } = this.state;

    let website = null;
    websites.forEach((w) => {
      w.url_patterns.forEach((urlPattern) => {
        if (urlPattern.trim() && !website) {
          const regEx = new RegExp(urlPattern.trim());
          if (regEx.test(url)) {
            website = w;
          }
        }
      });
    });

    return website;
  }

  getSelected(type) {
    const {
      selectedGroups,
      selectedUsers,
    } = this.state;

    let selected = [];
    if (type === 'groups') {
      selected = selectedGroups;
    }
    if (type === 'users') {
      selected = selectedUsers;
    }

    return selected.reduce((o, uuid) => ({ ...o, [uuid]: 1 }), {});
  }

  getStatus() {
    const {
      selectedFile,
      selectedFiles,
      modalMode,
      fileStatuses,
    } = this.props;

    if (modalMode === 'edit' && selectedFiles.length > 1) {
      return { id: -2 };
    }

    if (modalMode === 'upload') {
      const defaultStatus = fileStatuses.find(fs => (fs.default));
      if (defaultStatus) {
        return defaultStatus;
      }
    }

    return (selectedFile && selectedFile.status) ? selectedFile.status : null;
  }

  setDefaultMappingState() {
    const { modalMode } = this.props;

    if (modalMode === 'link') {
      this.setState({ mapping: false });
    } else {
      this.setState({ mapping: getSetting('use_exif_mapping_by_default') && getSetting('exif_mapping_enabled') });
    }
  }

  setDefaultCollabolators() {
    const { groups } = this.state;

    groups.forEach((group) => {
      if (group.default_in_upload) {
        this.addSelected(group.uuid, 'group');
      }
    });
  }

  loadUsers() {
    this.setState({ usersLoading: true });

    return APIgetUsers().then((response) => {
      const { data } = response;
      if (data) {
        this.setState({ users: data });
      }
      this.setState({ usersLoading: false });
    });
  }

  loadGroups() {
    this.setState({ groupsLoading: true });

    return APIgetGroups({ all: true }).then((response) => {
      const { data } = response;
      if (data) {
        this.setState({ groups: data }, () => {
          this.setDefaultCollabolators();
        });
      }
      this.setState({ groupsLoading: false });
    });
  }

  isLinkEditMode() {
    const {
      modalMode,
      selectedFile,
      selectedFiles,
    } = this.props;

    return !!(modalMode === 'link' && (
      selectedFiles.length > 0 ||
      selectedFile
    ));
  }

  handleAutoSave() {
    const { submittedFiles } = this.props;
    const {
      saveAfterUpload,
      awaitSaveAfterUpload,
      saving,
      cancelling,
    } = this.state;
    const uploadedFiles = submittedFiles.filter(sf => (sf.uploadStatus === 'completed'));

    if (
      awaitSaveAfterUpload &&
      saveAfterUpload &&
      submittedFiles.length === uploadedFiles.length &&
      !saving &&
      !cancelling
    ) {
      this.setState({
        awaitSaveAfterUpload: false,
      }, () => {
        this.handleSave();
      });
    }
  }

  triggerInputFile() {
    this.fileInput.current.click();
  }

  submitInitialFiles() {
    const {
      files,
      uploader,
    } = this.props;

    if (files) {
      uploader.methods.addFiles(files);
    }
  }

  initializeLink() {
    const {
      selectedFiles,
      submittedFiles,
      setSubmittedFiles,
    } = this.props;

    if (selectedFiles.length === 0) {
      const newLink = Object.assign({}, fileObject);
      newLink.id = uuidv4();
      newLink.type = 'link';
      newLink.uploadStatus = 'completed';
      newLink.collections = getCollectionsFromFiles(submittedFiles);
      const fileAccessType = getAccessTypeFromFiles(submittedFiles);
      newLink.public = fileAccessType.public;
      setSubmittedFiles([newLink]);
    }
  }

  handleAddUrl(url) {
    const {
      submittedFiles,
      setSubmittedFiles,
    } = this.props;

    const newLink = Object.assign({}, fileObject);
    newLink.id = uuidv4();
    newLink.type = 'link';
    newLink.uploadStatus = 'completed';
    newLink.path = url;
    newLink.collections = getCollectionsFromFiles(submittedFiles);
    const fileAccessType = getAccessTypeFromFiles(submittedFiles);
    newLink.public = fileAccessType.public;
    setSubmittedFiles(submittedFiles.concat([newLink]));
  }

  loadWebsites() {
    APIgetWebsites().then((response) => {
      if (response.data) {
        this.setState({ websites: response.data });
      }
    });
  }

  submitSelectedFiles() {
    const {
      selectedFiles,
      selectedFile,
      setSubmittedFiles,
    } = this.props;

    let files = selectedFiles;
    if (files.length === 0 && selectedFile) {
      files = [selectedFile];
    }

    let counter = 0;
    const submittedFiles = files
      .filter(sf => (userCan('file.edit', sf)))
      .map((sf) => {
        counter += 1;
        return {
          id: counter,
          uploadStatus: 'completed',
          selected: true,
          ...sf,
        };
      });
    setSubmittedFiles(submittedFiles);
  }

  submitFiles(e) {
    const { uploader } = this.props;

    uploader.methods.addFiles(e.target.files);
    this.fileInput.current.value = null;
  }

  toggle() {
    const {
      closeUploadModal,
      resetUploader,
    } = this.props;

    this.setState({
      uploadUuid: null,
      selectedGroups: [],
      selectedUsers: [],
    });
    resetUploader();
    closeUploadModal();
  }

  toggleNested() {
    const {
      nestedModal,
      saving,
      cancelling,
    } = this.state;

    if (saving || cancelling) {
      return;
    }

    this.setState({
      nestedModal: !nestedModal,
      closeAll: false,
    });
  }

  toggleAll() {
    const { nestedModal } = this.state;

    this.setState({
      nestedModal: !nestedModal,
      closeAll: true,
    });
  }

  isSelectAllChecked() {
    const { submittedFiles } = this.props;

    return submittedFiles.length > 0 &&
      submittedFiles.length === submittedFiles.filter(sf => (sf.selected)).length;
  }

  selectAllFiles() {
    const {
      submittedFiles,
      setSubmittedFiles,
    } = this.props;

    setSubmittedFiles(submittedFiles.map(uf => ({ ...uf, selected: true })));
  }

  unselectAllFiles() {
    const {
      submittedFiles,
      setSubmittedFiles,
    } = this.props;

    setSubmittedFiles(submittedFiles.map(uf => ({ ...uf, selected: false })));
  }

  toggleSelected(id) {
    const {
      modalMode,
      submittedFiles,
      setSubmittedFiles,
    } = this.props;
    const { mapping } = this.state;

    if (mapping && modalMode !== 'edit') {
      return;
    }

    const file = submittedFiles.find(sf => (sf.id === id));
    file.selected = !file.selected;
    setSubmittedFiles(submittedFiles);
  }

  handleFormChange(e = null) {
    if (!e) {
      this.setState({ timestamp: new Date() });
      return;
    }

    const {
      name,
      value,
    } = e.target;
    const {
      submittedFiles,
      setSubmittedFiles,
    } = this.props;

    const newSubmittedFiles = submittedFiles.map((sf) => {
      const nsf = sf;
      if (nsf.selected) {
        if (name === 'fileName') {
          nsf.name = value;
        }
        if (name === 'filePrefix') {
          nsf.prefix = value;
        }
        if (name === 'fileSuffix') {
          nsf.suffix = value;
        }
        if (name === 'fileDescription') {
          nsf.description = value;
        }
        if (name === 'fileAccess') {
          if (value === 'public') {
            nsf.public = true;
          } else {
            nsf.public = false;
          }
        }
        if (name === 'fileStatus') {
          if (value === '') {
            nsf.status = null;
          } else {
            nsf.status = this.getFileStatus(value);
          }

          delete nsf.errors?.status;
        }
        if (name === 'fileDate') {
          nsf.original_datetime = value;
        }
        if (name === 'fileExpirationDate') {
          nsf.expires_at = value;

          delete nsf.errors?.expirationDate;
        }
        if (name === 'fileUrl') {
          nsf.path = value;
        }
        if (name === 'linkHtmlCode') {
          nsf.html_code = value;
        }
      }

      if (nsf.type === 'link') {
        nsf.website = this.getWebsite(nsf.path);
        nsf.uploadStatus = 'completed';
      }

      return nsf;
    });

    setSubmittedFiles(newSubmittedFiles);
  }

  handleClearPrefixes(e) {
    e.preventDefault();

    const {
      submittedFiles,
      setSubmittedFiles,
    } = this.props;

    const newSubmittedFiles = submittedFiles.map((sf) => {
      const nsf = sf;
      if (nsf.selected) {
        nsf.prefix = '';
      }

      return nsf;
    });

    setSubmittedFiles(newSubmittedFiles);
  }

  handleClearSuffixes(e) {
    e.preventDefault();

    const {
      submittedFiles,
      setSubmittedFiles,
    } = this.props;

    const newSubmittedFiles = submittedFiles.map((sf) => {
      const nsf = sf;
      if (nsf.selected) {
        nsf.suffix = '';
      }

      return nsf;
    });

    setSubmittedFiles(newSubmittedFiles);
  }

  handleTaxonomyChange(values, taxonomyId, removed = []) {
    const {
      submittedFiles,
      setSubmittedFiles,
    } = this.props;
    const { removedTerms } = this.state;

    const newRemovedTerms = removedTerms || [];
    const newSubmittedFiles = submittedFiles.map((sf) => {
      const nsf = sf;
      if (nsf.selected) {
        let newTerms = window._.uniqBy(nsf.terms
          .filter(t => (parseInt(t.taxonomy_id) === parseInt(taxonomyId))).concat(values), 'id');
        if (removed) {
          removed.forEach((r) => {
            newTerms = newTerms.filter(nt => (parseInt(nt.id) !== parseInt(r.value)));
            newRemovedTerms.push(r.value);
          });
        }
        nsf.terms = nsf.terms
          .filter(t => (parseInt(t.taxonomy_id) !== parseInt(taxonomyId)))
          .concat(newTerms);
        if (nsf.errors && nsf.errors.taxonomy) {
          nsf.errors.taxonomy = nsf.errors.taxonomy.filter(t => t !== taxonomyId);
        }
      }
      return nsf;
    });

    setSubmittedFiles(newSubmittedFiles);
    this.setState({ removedTerms: newRemovedTerms });
  }

  handleMetadataGroupChange(metadataGroup) {
    const {
      submittedFiles,
      setSubmittedFiles,
    } = this.props;

    const newSubmittedFiles = submittedFiles.map((sf) => (sf.selected
      ? { ...sf, metadata_group: metadataGroup.value }
      : sf));

    setSubmittedFiles(newSubmittedFiles);
  }

  handleCollectionChange(values) {
    const {
      submittedFiles,
      setSubmittedFiles,
    } = this.props;

    const newSubmittedFiles = submittedFiles.map((sf) => {
      const nsf = sf;
      if (values) {
        if (values.uuid) {
          nsf.collections.push({
            uuid: values.uuid,
            name: values.name,
            spreadPermissions: values.spreadPermissions,
            accessIcon: values.accessIcon,
            accessDescription: values.accessDescription,
          });
        } else {
          nsf.collections = values.map(v => ({
            uuid: v.uuid,
            name: v.name,
            spreadPermissions: v.spreadPermissions,
            accessIcon: v.accessIcon,
            accessDescription: v.accessDescription,
          }));
        }
      } else {
        nsf.collections = [];
      }
      return nsf;
    });

    setSubmittedFiles(newSubmittedFiles);
  }

  handleCustomFieldChange(customField) {
    const {
      submittedFiles,
      setSubmittedFiles,
    } = this.props;

    const newSubmittedFiles = submittedFiles.map((sf) => {
      const nsf = sf;
      if (nsf.selected) {
        nsf.custom_fields = nsf.custom_fields.filter(cf => (cf.id !== customField.id));
        nsf.custom_fields.push(customField);
      }
      if (nsf.errors) {
        if (nsf.errors.customFields) {
          nsf.errors.customFields = nsf.errors.customFields.filter(cf => cf !== customField.id);
        }
        if (nsf.errors.customFieldsUrls) {
          nsf.errors.customFieldsUrls =
            nsf.errors.customFieldsUrls.filter(cf => cf !== customField.id);
        }
      }
      return nsf;
    });

    setSubmittedFiles(newSubmittedFiles);
  }

  handleMappingSwitch(e) {
    const { value } = e.target;
    this.setState({ mapping: value === '1' }, () => {
      if (value === '1') {
        this.selectAllFiles();
      }
    });
  }

  handleSave() {
    const {
      intl,
      modalMode,
      profile,
      submittedFiles,
      setSubmittedFiles,
    } = this.props;

    this.setState({
      saving: true,
      collectionError: false,
    });

    if (
      modalMode !== 'edit' &&
      getSetting('cs1') &&
      getCollectionsFromFiles(submittedFiles).length === 0
    ) {
      this.setState({
        saving: false,
        collectionError: true,
      });
      return;
    }

    const isValidationError = this.handleSaveValidate();

    if (isValidationError) {
      this.setState({ saving: false });
      return;
    }

    if (modalMode === 'link') {
      const newSubmittedFiles = submittedFiles.map(sf => ({
        ...sf,
        uploadStatus: isValidUrl(sf.path) ? 'completed' : 'invalid',
      }));
      setSubmittedFiles(newSubmittedFiles);
      if (newSubmittedFiles.filter(sf => (sf.uploadStatus === 'invalid')).length > 0) {
        this.setState({ saving: false });
        return;
      }
    }

    let groupType = 'upload';
    if (modalMode === 'edit') {
      if (this.isLinkEditMode()) {
        groupType = 'edit_link_cards';
      } else {
        groupType = 'edit_files';
      }
    } else if (modalMode === 'link') {
      if (this.isLinkEditMode()) {
        groupType = 'edit_link_cards';
      } else {
        groupType = 'create_link_cards';
      }
    }

    if (modalMode === 'edit' || modalMode === 'link') {
      APIcreateFilesGroup({ type: groupType }).then((response) => {
        const { data } = response;
        if (data) {
          this.setState({ uploadUuid: data.uuid }, () => {
            this.handleSaveFiles();
          });
        }
      });
    } else {
      if (accountUsageLock(profile.client) || subscriptionExpired(profile.client)) {
        this.setState({ saving: false });
        addFlashMessage({
          type: 'danger',
          text: intl.formatMessage({ defaultMessage: 'The storage limit for this account has been exceeded' }),
        });
        return;
      }

      APIcreateFilesGroup({ type: groupType }).then((response) => {
        const { data } = response;
        if (data) {
          this.setState({ uploadUuid: data.uuid }, () => {
            let folders = submittedFiles.filter(sf => (sf.folder)).map(sf => (sf.folder.replace('\\', '/')));
            folders = [...new Set(folders)];
            if (folders.length === 0) {
              this.handleSaveFiles();
            } else {
              APIcreateFolderCollections({
                folders,
                parent_collection_uuid: getCollectionsFromFiles(submittedFiles).length > 0 ?
                  getCollectionsFromFiles(submittedFiles)[0].uuid : null,
              }).then((res) => {
                const folderCollections = res.data;
                this.setState({
                  folderCollections: res.data,
                });
                const newSubmittedFiles = submittedFiles.map(sf => ({
                  ...sf,
                  collections: (sf.folder && folderCollections[sf.folder]) ?
                    [folderCollections[sf.folder]] : sf.collections,
                }));

                Object.keys(folderCollections).forEach((folder) => {
                  eventDispatch('collectionUpdatedTree', folderCollections[folder]);
                });

                setSubmittedFiles(newSubmittedFiles);
                setTimeout(() => {
                  this.handleSaveFiles();
                }, 500);
              });
            }
          });
        }
      });
    }
  }

  handleResetValidation() {
    const { submittedFiles, setSubmittedFiles } = this.props;

    const hasAnyFileErrors = submittedFiles.find(f => fileHasErrors(f.errors));
    if (!hasAnyFileErrors) return;

    const newSubmittedFiles = submittedFiles.map(sf => ({
      ...sf,
      errors: {
        taxonomy: [],
      },
    }));

    setSubmittedFiles(newSubmittedFiles);
  }

  handleSaveValidate() {
    const { mapping } = this.state;
    const {
      taxonomies,
      metadataGroups,
      customFields,
      submittedFiles,
      setSubmittedFiles,
      modalMode,
    } = this.props;

    let isError = false;

    const newSubmittedFiles = submittedFiles.map(sf => {
      const taxonomyErrors = [];
      const customFieldsErrors = [];
      const customFieldsUrlsErrors = [];
      let expirationDateError = false;

      if (!mapping) {
        if (userHasFeature('custom-categories')) {
          let taxonomiesToValidate = taxonomies;
          const taxonomiesWithoutGroups = taxonomies.filter(
            t => !t.ai_tagging && t.metadata_groups?.length === 0 && getTaxonomyRoleSetting(t, 'read_only') !== true,
          );

          // Limit validation to group taxonomies
          if (
            metadataGroups?.length > 0 &&
            sf.metadata_group
          ) {
            const selectedGroup = metadataGroups.find(
              g => `${g.id}` === `${sf.metadata_group}`,
            );

            if (selectedGroup) {
              const groupTaxonomies =
                taxonomies.filter(t => selectedGroup.taxonomies.includes(t.id) && getTaxonomyRoleSetting(t, 'read_only') !== true);
              taxonomiesToValidate = [...groupTaxonomies, ...taxonomiesWithoutGroups];
            }
          } else {
            taxonomiesToValidate = taxonomiesWithoutGroups;
          }

          taxonomiesToValidate.forEach(t => {
            if (
              t.required &&
              !(sf.terms && sf.terms.some(term => term.taxonomy_id === t.id))
            ) {
              isError = true;
              taxonomyErrors.push(t.id);
            }
          });
        }

        if (userHasFeature('custom-fields')) {
          let customFieldsToValidate = customFields;
          const customFieldsWithoutGroups = customFields
            .filter(t => t.metadata_groups?.length === 0);

          // Limit validation to group taxonomies
          if (
            metadataGroups?.length > 0 &&
            sf.metadata_group
          ) {
            const selectedGroup = metadataGroups.find(
              g => `${g.id}` === `${sf.metadata_group}`,
            );

            if (selectedGroup) {
              const groupCustomFields = customFields
                .filter(cf => selectedGroup.custom_fields.includes(cf.id));
              customFieldsToValidate = [...groupCustomFields, ...customFieldsWithoutGroups];
            }
          } else {
            customFieldsToValidate = customFieldsWithoutGroups;
          }

          customFieldsToValidate.forEach(cf => {
            if (cf.required && !(sf.custom_fields.find(fileCF => (fileCF.id === cf.id))?.value)) {
              isError = true;
              customFieldsErrors.push(cf.id);
            }

            if (cf.type === 'url') {
              const fieldValue = sf.custom_fields.find(fileCF => (fileCF.id === cf.id))?.value;

              if (fieldValue && !linkify.test(fieldValue)) {
                isError = true;
                customFieldsUrlsErrors.push(cf.id);
              }
            }
          });
        }

        if (userHasFeature('expiration-date') && getSetting('expiration_date') && getSetting('expiration_date_required')) {
          if (!sf.expires_at) {
            isError = true;
            expirationDateError = true;
          }
        }
      }

      let statusError = false;
      if (userHasFeature('file-status') && getSetting('file_status_required') && modalMode !== 'link') {
        if (!sf.status) {
          isError = true;
          statusError = true;
        }
      }

      return {
        ...sf,
        errors: {
          taxonomy: taxonomyErrors,
          customFields: customFieldsErrors,
          customFieldsUrls: customFieldsUrlsErrors,
          ...(expirationDateError && { expirationDate: true }),
          ...(statusError && { status: true }),
        },
      };
    });

    setSubmittedFiles(newSubmittedFiles);
    return isError;
  }

  getPrefixOffset() {
    const { prefixOffset } = this.state;

    const value = prefixOffset && prefixOffset.length > 0 && /^[a-zA-Z]+$/.test(prefixOffset) ? lettersToIndex(prefixOffset) : prefixOffset;

    const parsed = Number.parseInt(value) - 1;

    return prefixOffset && !Number.isNaN(parsed) && parsed >= 0 ? parsed : 0;
  }

  getSuffixOffset() {
    const { suffixOffset } = this.state;

    const value = suffixOffset && suffixOffset.length > 0 && /^[a-zA-Z]+$/.test(suffixOffset) ? lettersToIndex(suffixOffset) : suffixOffset;

    const parsed = Number.parseInt(value) - 1;

    return suffixOffset && !Number.isNaN(parsed) && parsed >= 0 ? parsed : 0;
  }

  handleGetFilePrefix(file) {
    const {
      includePrefix,
      prefixLabel,
      prefixSeparator,
      prefixOffset,
    } = this.state;
    const {
      modalMode,
    } = this.props;

    if (modalMode === 'upload' && includePrefix) {
      return getFilePrefix(
        file.id + 1 + this.getPrefixOffset(),
        prefixLabel,
        prefixSeparator,
        prefixOffset,
      );
    }

    if (modalMode === 'edit') {
      if (file.prefix || file.prefix === '') {
        return file.prefix;
      }

      return file.attributes?.prefix ? file.attributes.prefix : '';
    }

    return '';
  }

  handleGetFileSuffix(file) {
    const {
      includeSuffix,
      suffixLabel,
      suffixSeparator,
      suffixOffset,
    } = this.state;
    const {
      modalMode,
    } = this.props;

    if (modalMode === 'upload' && includeSuffix) {
      return getFileSuffix(
        file.id + 1 + this.getSuffixOffset(),
        suffixLabel,
        suffixSeparator,
        suffixOffset,
      );
    }

    if (modalMode === 'edit') {
      if (file.suffix || file.suffix === '') {
        return file.suffix;
      }

      return file.attributes?.suffix ? file.attributes.suffix : '';
    }

    return '';
  }

  handleSaveFiles() {
    const {
      intl,
      reloadFiles,
      reloadCollection,
      reloadCollections,
      resetFilesParams,
      updateFileAction,
      modalMode,
      location,
      history,
      submittedFiles,
      hasFolder,
    } = this.props;
    const {
      uploadUuid,
      mapping,
      selectedGroups,
      selectedUsers,
      removedTerms,
      folderCollections,
      includeSuffix,
    } = this.state;

    let counter = 0;
    const promiseProducer = () => {
      if (counter < submittedFiles.length) {
        const file = submittedFiles[counter];
        counter += 1;
        if (modalMode === 'link' && !this.isLinkEditMode()) {
          return APIcreateFile({
            ...file,
            searchable: true,
            uploadUuid,
            mapping: false,
            accessGroups: (modalMode === 'edit' || file.public) ? [] : selectedGroups,
            accessUsers: (modalMode === 'edit' || file.public) ? [] : selectedUsers,
            removedTerms,
          }).then(() => {
            this.setState({ savedFiles: counter });
          });
        }
        return updateFileAction({
          ...file,
          name: includeSuffix && !file.name ?
            getFileNameWithoutExtension(file.original_name, getFileExtension(file)) :
            file.name,
          status: !file.status ? -1 : file.status,
          searchable: true,
          uploadStatus: (modalMode === 'edit') ? 'updated' : 'completed',
          uploadUuid,
          mapping: (modalMode === 'edit') ? false : mapping,
          accessGroups: (modalMode === 'edit' || file.public) ? [] : selectedGroups,
          accessUsers: (modalMode === 'edit' || file.public) ? [] : selectedUsers,
          removedTerms,
          metadata_group:
            _.isObject(file.metadata_group) ? file.metadata_group.id : file.metadata_group,
          prefix: this.handleGetFilePrefix(file),
          suffix: this.handleGetFileSuffix(file),
        }).then(() => {
          this.setState({ savedFiles: counter });
        });
      }
      return null;
    };

    const pool = new PromisePool(promiseProducer, 2);
    pool.start().then(() => {
      if (modalMode === 'edit' || this.isLinkEditMode()) {
        addFlashMessage({
          type: 'success',
          text: intl.formatMessage({ defaultMessage: 'Your changes have been saved' }),
        });
      } else {
        let button = false;
        if (location.pathname !== '/files') {
          button = {
            url: '/files',
            text: intl.formatMessage({ defaultMessage: 'Browse all your files' }),
          };
        }
        addFlashMessage({
          type: 'success',
          text: intl.formatMessage({ defaultMessage: 'Your files have been stored' }),
          button,
        });

        if (modalMode === 'link') {
          sendTrackingEvent('link-add-complete', {
            links: submittedFiles.length,
          });
        } else {
          sendTrackingEvent('upload-complete', {
            files: submittedFiles.length,
          });
        }

        if (submittedFiles[0] && submittedFiles[0].collections.length > 0) {
          if (submittedFiles[0].collections[0].uuid) {
            if (!hasFolder) {
              const collectionUrl = `/collections/${submittedFiles[0].collections[0].uuid}`;
              if (window.location.pathname === collectionUrl) {
                reloadCollection(submittedFiles[0].collections[0].uuid);
                reloadFiles('position');
              } else {
                resetFilesParams();
                history.push(collectionUrl);
              }
            } else {
              reloadFiles('position');
              reloadCollections();
            }
          }
        } else if (window.location.pathname === '/files' || window.location.pathname === '/') {
          reloadFiles();
        }
      }

      const uploadCollection = folderCollections ? Object.values(folderCollections)[0] : null;

      eventDispatch('filesUploaded', {
        filesCount: submittedFiles.length,
        collection: uploadCollection,
      });
      APIfinishFilesGroup(uploadUuid);
      this.setState({
        saving: false,
        savedFiles: 0,
        saveAfterUpload: false,
        folderCollections: null,
      });
      this.toggle();
    });
  }

  handleCancelFiles() {
    const {
      modalMode,
      uploader,
      submittedFiles,
      setSubmittedFiles,
    } = this.props;

    if (modalMode === 'edit' || modalMode === 'link') {
      setSubmittedFiles([]);
      this.toggleAll();
      return;
    }

    if (submittedFiles.length === 0) {
      this.toggle();
    }

    this.toggleNested();
    this.setState({
      cancelling: true,
      cancelledFiles: 0,
    });

    uploader.methods.cancelAll();

    let counter = 0;
    const promiseProducer = () => {
      const { cancelledFiles } = this.state;
      if (counter < submittedFiles.length) {
        const file = submittedFiles[counter];
        counter += 1;
        if (file.uuid && file.uploadStatus === 'completed') {
          return APIdeleteFile(file.uuid).then(() => {
            this.setState({ cancelledFiles: cancelledFiles + 1 });
          });
        }
      }
      return null;
    };

    const pool = new PromisePool(promiseProducer, 1);
    pool.start().then(() => {
      this.setState({
        cancelling: false,
        submittedFiles: [],
      });
      this.toggle();
    });
  }

  handleRemoveFile(id) {
    const {
      intl,
      openConfirmationModal,
      uploader,
      modalMode,
    } = this.props;

    const modalParams = {
      title: intl.formatMessage({ defaultMessage: 'Are you sure?' }),
      text: modalMode === 'link' ?
        intl.formatMessage({ defaultMessage: 'Are you sure you want to remove this link?' }) :
        intl.formatMessage({ defaultMessage: 'Are you sure you want to remove this file?' }),
      confirmText: intl.formatMessage({ defaultMessage: 'Remove' }),
      onConfirm: () => {
        uploader.methods.cancel(id);
        return Promise.resolve();
      },
    };

    openConfirmationModal(modalParams);
  }

  saveButtonText() {
    const { intl, submittedFiles } = this.props;
    const {
      saving,
      cancelling,
      savedFiles,
      cancelledFiles,
    } = this.state;
    const submittedFilesCount = submittedFiles.length;

    if (saving) {
      return intl.formatMessage({ defaultMessage: 'Saving {savedFiles} of {submittedFilesCount} files...' }, {
        savedFiles,
        submittedFilesCount,
      });
    }
    if (cancelling) {
      return intl.formatMessage({ defaultMessage: 'Canceling {cancelledFiles} of {submittedFilesCount} files' }, {
        cancelledFiles,
        submittedFilesCount,
      });
    }

    return intl.formatMessage({ defaultMessage: 'Save' });
  }

  handleSwitchGroup(groupUuid) {
    const { selectedGroups } = this.state;

    const group = selectedGroups.find(sg => (sg === groupUuid));
    if (group) {
      this.setState({ selectedGroups: selectedGroups.filter(sg => (sg !== groupUuid)) });
    } else {
      selectedGroups.push(groupUuid);
      this.setState({ selectedGroups });
    }
  }

  handleSwitchUser(userUuid) {
    const { selectedUsers } = this.state;

    const user = selectedUsers.find(su => (su === userUuid));
    if (user) {
      this.setState({ selectedUsers: selectedUsers.filter(su => (su !== userUuid)) });
    } else {
      selectedUsers.push(userUuid);
      this.setState({ selectedUsers });
    }
  }

  addSelected(uuid, type) {
    if (type === 'group') {
      this.handleSwitchGroup(uuid);
    }
    if (type === 'user') {
      this.handleSwitchUser(uuid);
    }
  }

  removeSelected(uuid, type) {
    if (type === 'group') {
      this.handleSwitchGroup(uuid);
    }
    if (type === 'user') {
      this.handleSwitchUser(uuid);
    }
  }

  addNewGroup(group) {
    this.loadGroups().then(() => {
      this.addSelected(group.uuid, 'group');
    });
  }

  addNewUser(user) {
    this.loadUsers().then(() => {
      this.addSelected(user.uuid, 'user');
    });
  }

  handleSaveAfterUploadChange() {
    const { saveAfterUpload } = this.state;

    this.setState({ saveAfterUpload: !saveAfterUpload });
  }

  handleUploadedFilesFilter(value) {
    this.setState({ uploadedFilesFilter: value });
  }

  handleRetryAllFailed() {
    const {
      handleRetryFile,
      submittedFiles,
    } = this.props;

    submittedFiles.filter(sf => sf.uploadStatus === 'failed').forEach(sf => {
      handleRetryFile(sf.id);
    });
  }

  handleSwitchTab(activeTab) {
    this.setState({ activeTab });
  }

  handleIncludePrefix(includePrefix) {
    this.setState({ includePrefix });
  }

  handlePrefixLabel(prefixLabel) {
    const { prefixOffset } = this.state;

    this.setState({ prefixLabel });

    if (prefixLabel === '1' && !/^[0-9]+$/.test(prefixOffset)) {
      this.setState({ prefixOffset: '' });
    } else if (prefixLabel !== '1' && /^[0-9]+$/.test(prefixOffset)) {
      this.setState({ prefixOffset: '' });
    }
  }

  handlePrefixSeparator(prefixSeparator) {
    this.setState({ prefixSeparator });
  }

  handleIncludeSuffix(includeSuffix) {
    this.setState({ includeSuffix });
  }

  handleSuffixLabel(suffixLabel) {
    const { suffixOffset } = this.state;

    this.setState({ suffixLabel });

    if (suffixLabel === '1' && !/^[0-9]+$/.test(suffixOffset)) {
      this.setState({ suffixOffset: '' });
    } else if (suffixLabel !== '1' && /^[0-9]+$/.test(suffixOffset)) {
      this.setState({ suffixOffset: '' });
    }
  }

  handleSuffixSeparator(suffixSeparator) {
    this.setState({ suffixSeparator });
  }

  handlePrefixOffset(prefixOffset) {
    const { prefixLabel } = this.state;
    if (!prefixLabel) return;
    if (prefixLabel === '1') {
      const numericOffset = String(prefixOffset).replace(/[^0-9]/g, '');
      this.setState({ prefixOffset: numericOffset });
    } else {
      const letterOffset = String(prefixOffset).replace(/[^a-zA-Z]/g, '');
      this.setState({ prefixOffset: letterOffset });
    }
  }

  handleSuffixOffset(suffixOffset) {
    const { suffixLabel } = this.state;
    if (!suffixLabel) return;
    if (suffixLabel === '1') {
      const numericOffset = String(suffixOffset).replace(/[^0-9]/g, '');
      this.setState({ suffixOffset: numericOffset });
    } else {
      const letterOffset = String(suffixOffset).replace(/[^a-zA-Z]/g, '');
      this.setState({ suffixOffset: letterOffset });
    }
  }

  render() {
    const {
      nestedModal,
      closeAll,
      saving,
      cancelling,
      mapping,
      selectedGroups,
      collectionError,
      timestamp,
      usersLoading,
      groupsLoading,
      uploadedFilesFilter,
      activeTab,
      includePrefix,
      prefixLabel,
      prefixSeparator,
      includeSuffix,
      suffixLabel,
      suffixSeparator,
      prefixOffset,
      suffixOffset,
    } = this.state;
    const {
      intl,
      profile,
      uploadModal,
      modalMode,
      connectDropTarget,
      isOver,
      openAddUrlModal,
      uploader,
      submittedFiles,
      handleRetryFile,
    } = this.props;
    const isSelectAllChecked = this.isSelectAllChecked();
    const uploadedFiles = submittedFiles.filter(sf => (sf.uploadStatus === 'completed'));
    const allFailedFilesCount = submittedFiles.filter(sf => (sf.uploadStatus === 'failed' || fileHasErrors(sf.errors))).length;
    const failedUploadFilesCount = submittedFiles.filter(sf => (sf.uploadStatus === 'failed')).length;
    const selectedFiles = submittedFiles.filter(sf => (sf.selected));
    const isEdit = modalMode === 'edit';
    const isLink = modalMode === 'link';
    const isMapping = mapping && !isEdit;
    const accessTypeFromFiles = getAccessTypeFromFiles(submittedFiles);
    const collectionsFromFiles = getCollectionsFromFiles(submittedFiles);
    const showFileAccess = (collectionsFromFiles.length === 0 ||
      (collectionsFromFiles.length === 1 && !collectionsFromFiles[0].spreadPermissions));
    const showTabs = modalMode === 'upload';

    if (modalMode === 'upload' && (!profile || !userCan('file.upload'))) {
      return null;
    }

    return (
      <Modal
        /* eslint-disable react/no-find-dom-node */
        ref={(instance) => {
          if (!isEdit && !isLink) {
            connectDropTarget(findDOMNode(instance));
          }
        }}
        /* eslint-enable react/no-find-dom-node */
        isOpen={uploadModal}
        keyboard={false}
        toggle={this.toggleNested}
        className={`modal-upload modal-xl${getSetting('cs1') ? ' cs1' : ''}`}
      >
        <UploadDropOverlay show={isOver} />
        <ModalHeader toggle={this.toggleNested}>
          {this.getHeaderTitle()}
        </ModalHeader>
        <ModalBody className="modal-body-split">
          <div className="modal-body-sidebar">
            <div className="modal-body-sidebar-header">
              <div className="uploaded-files-summary">
                <div className="uploaded-files-summary-title-wrapper">
                  <h5 className="uploaded-files-summary-title">
                    {this.getListTitle()}
                  </h5>
                  <span className={`checkbox-wrapper${isMapping ? ' hidden' : ''}`}>
                    <Input
                      type="checkbox"
                      className="input-check check-l"
                      id="CheckboxSelectAll"
                      checked={isSelectAllChecked}
                      onChange={() => {
                        if (isSelectAllChecked) {
                          this.unselectAllFiles();
                        } else {
                          this.selectAllFiles();
                        }
                      }}
                    />
                    <UncontrolledTooltip placement="bottom" target="CheckboxSelectAll">
                      {isSelectAllChecked ?
                        intl.formatMessage({ defaultMessage: 'Unselect all {isLink, select, true {links} other {files}}' }, { isLink }) :
                        intl.formatMessage({ defaultMessage: 'Select all {isLink, select, true {links} other {files}}' }, { isLink })}
                    </UncontrolledTooltip>
                  </span>
                </div>
                {allFailedFilesCount > 0 && (
                  <div className="uploaded-files-filter">
                    <ButtonGroup size="sm">
                      <Button
                        color={uploadedFilesFilter === 'all' ? 'primary' : 'link'}
                        id="uploaded-files-filter-all"
                        onClick={() => this.handleUploadedFilesFilter('all')}
                      >
                        <i className="far fa-list-ul" />
                        ({submittedFiles.length})
                      </Button>
                      <UncontrolledTooltip fade={false} placement="bottom" target="uploaded-files-filter-all">
                        {intl.formatMessage({ defaultMessage: 'All files' })}
                      </UncontrolledTooltip>
                      <Button
                        color={uploadedFilesFilter === 'failed' ? 'primary' : 'link'}
                        id="uploaded-files-filter-failed"
                        onClick={() => this.handleUploadedFilesFilter('failed')}
                      >
                        <i className="far fa-file-xmark" />
                        ({allFailedFilesCount})
                      </Button>
                      <UncontrolledTooltip fade={false} placement="bottom" target="uploaded-files-filter-failed">
                        {intl.formatMessage({ defaultMessage: 'Failed files' })}
                      </UncontrolledTooltip>
                    </ButtonGroup>
                    {failedUploadFilesCount > 0 && (
                      <Button
                        color="primary"
                        onClick={() => this.handleRetryAllFailed()}
                        size="sm"
                        className="uploaded-files-retry-failed"
                      >
                        {intl.formatMessage({ defaultMessage: 'Retry all failed files' })}
                      </Button>
                    )}
                  </div>
                )}
              </div>
            </div>
            <ul className="uploaded-files-list">
              {submittedFiles.map(f => (
                <UploadFile
                  key={f.id}
                  id={f.id}
                  uploader={uploader}
                  toggleSelected={this.toggleSelected}
                  handleRetry={handleRetryFile}
                  handleRemove={this.handleRemoveFile}
                  file={f}
                  collections={collectionsFromFiles}
                  mode={modalMode}
                  isLinkEdit={this.isLinkEditMode()}
                  isMapping={isMapping}
                  uploadedFilesFilter={uploadedFilesFilter}
                  includePrefix={includePrefix}
                  prefix={this.handleGetFilePrefix(f)}
                  includeSuffix={includeSuffix}
                  suffix={this.handleGetFileSuffix(f)}
                />
              ))}
            </ul>
          </div>
          <div className="modal-body-content">
            {showTabs && (
              <UploadModalTabs
                activeTab={activeTab}
                handleSwitchTab={this.handleSwitchTab}
              />
            )}
            <div className={classnames({ hidden: activeTab !== 'details' })}>
              {(!isEdit && !isLink && getSetting('exif_mapping_enabled')) && (
                <FormGroup className="mapping-switch" check inline>
                  <Label for="mapping-switch-on">
                    <Input
                      id="mapping-switch-on"
                      type="radio"
                      name="mapping"
                      value="1"
                      defaultChecked={mapping}
                      onChange={this.handleMappingSwitch}
                    />
                    {intl.formatMessage({ defaultMessage: 'Automatic metadata mapping' })}
                  </Label>
                  <Label for="mapping-switch-off">
                    <Input
                      id="mapping-switch-off"
                      type="radio"
                      name="mapping"
                      value="0"
                      defaultChecked={!mapping}
                      onChange={this.handleMappingSwitch}
                    />
                    {intl.formatMessage({ defaultMessage: 'Manual metadata' })}
                  </Label>
                </FormGroup>
              )}
              {!isMapping ? (
                <>
                  {selectedFiles.length > 0 && (
                  <div className="uploaded-files-content">
                    <h3>
                      {intl.formatMessage({ defaultMessage: 'Selected {selectedFilesCount} of {submittedFilesCount} {isLink, select, true {links} other {files}}' }, {
                        selectedFilesCount: selectedFiles.length,
                        submittedFilesCount: submittedFiles.length,
                        isLink,
                      })}
                    </h3>
                    <ErrorBoundary>
                      <UploadFileForm
                        {...this.state}
                        mode="files"
                        selectedFiles={selectedFiles}
                        selectedUsersObject={this.getSelected('users')}
                        selectedGroupsObject={this.getSelected('groups')}
                        loading={usersLoading || groupsLoading}
                        saving={saving}
                        handleAddItem={this.addSelected}
                        handleRemoveItem={this.removeSelected}
                        handleAddNewGroup={this.addNewGroup}
                        handleAddNewUser={this.addNewUser}
                        accessTypeFromFiles={accessTypeFromFiles}
                        collectionError={collectionError}
                        isLinkEdit={this.isLinkEditMode()}
                        showFileAccess={showFileAccess}
                        handleFormChange={this.handleFormChange}
                        handleTaxonomyChange={this.handleTaxonomyChange}
                        handleMetadataGroupChange={this.handleMetadataGroupChange}
                        handleCollectionChange={this.handleCollectionChange}
                        handleCustomFieldChange={this.handleCustomFieldChange}
                        handleSwitchGroup={this.handleSwitchGroup}
                        handleClearPrefixes={this.handleClearPrefixes}
                        handleClearSuffixes={this.handleClearSuffixes}
                      />
                    </ErrorBoundary>
                  </div>
                  )}
                </>
              ) : (
                <div className="uploaded-files-content">
                  <p>
                    {intl.formatMessage({
                      defaultMessage: `Your files metadata will be automatically mapped to
                      Stockpress fields and Tag Categories.`,
                    })}
                  </p>
                  {selectedFiles.length > 0 && (
                    <ErrorBoundary>
                      <Form className="upload-form">
                        <FormGroup className="row file-options">
                          {!isLink && (
                            <Col className="file-status-field" sm={6} md={6} lg={3}>
                              <FileStatusSelect
                                defaultValue={this.getStatus()}
                                isEdit={(isEdit && selectedFiles.length > 0)}
                                selectedFiles={selectedFiles}
                                handleChange={this.handleFormChange}
                                scope="upload"
                              />
                            </Col>
                          )}
                          {showFileAccess && (
                            <Col sm={6} md={6} lg={3}>
                              <UploadFileAccess
                                isEdit={isEdit}
                                isLink={isLink}
                                selectedFiles={selectedFiles}
                                timestamp={timestamp}
                                handleFormChange={this.handleFormChange}
                              />
                            </Col>
                          )}
                          {userHasFeature('created-date-field') && (
                            <Col sm={6} md={6} lg={3}>
                              <UploadFileDate
                                isEdit={isEdit}
                                selectedFiles={selectedFiles}
                                timestamp={timestamp}
                                handleFormChange={this.handleFormChange}
                              />
                            </Col>
                          )}
                          {getSetting('expiration_date') && (
                            <Col className="expiration-date-field" sm={6} md={6} lg={3}>
                              <UploadFileExpirationDate
                                isEdit={isEdit}
                                selectedFiles={selectedFiles}
                                timestamp={timestamp}
                                handleFormChange={this.handleFormChange}
                              />
                            </Col>
                          )}
                        </FormGroup>
                        <UploadFileCollection
                          isLinkEdit={this.isLinkEditMode()}
                          selectedFiles={selectedFiles}
                          collectionError={collectionError}
                          handleCollectionChange={this.handleCollectionChange}
                        />
                        {(getSetting('cs1') && !accessTypeFromFiles.public && showFileAccess) && (
                          <UploadFileAccessGroups
                            {...this.state}
                            selectedGroups={selectedGroups}
                            handleSwitchGroup={this.handleSwitchGroup}
                          />
                        )}
                        {(!getSetting('cs1') && !accessTypeFromFiles.public && showFileAccess) && (
                          <AccessModalAccess
                            {...this.state}
                            mode="files"
                            selectedUsers={this.getSelected('users')}
                            selectedGroups={this.getSelected('groups')}
                            loading={usersLoading || groupsLoading}
                            saving={saving}
                            handleAddItem={this.addSelected}
                            handleRemoveItem={this.removeSelected}
                            handleAddNewGroup={this.addNewGroup}
                            handleAddNewUser={this.addNewUser}
                          />
                        )}
                      </Form>
                    </ErrorBoundary>
                  )}
                </div>
              )}
            </div>
            <div
              className={classnames('uploaded-files-content uploaded-files-content-advanced', { hidden: activeTab !== 'advanced' })}
            >
              <Form className="upload-form">
                <FileUploadAddPrefixSuffix
                  includePrefix={includePrefix}
                  handleIncludePrefix={this.handleIncludePrefix}
                  handlePrefixLabel={this.handlePrefixLabel}
                  handlePrefixSeparator={this.handlePrefixSeparator}
                  prefixLabel={prefixLabel}
                  prefixSeparator={prefixSeparator}
                  includeSuffix={includeSuffix}
                  handleIncludeSuffix={this.handleIncludeSuffix}
                  handleSuffixLabel={this.handleSuffixLabel}
                  handleSuffixSeparator={this.handleSuffixSeparator}
                  suffixLabel={suffixLabel}
                  suffixSeparator={suffixSeparator}
                  prefixOffset={prefixOffset}
                  handlePrefixOffset={this.handlePrefixOffset}
                  suffixOffset={suffixOffset}
                  handleSuffixOffset={this.handleSuffixOffset}
                  identifier="upload-modal"
                  zIndex={99999}
                />
              </Form>
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="justify-sb">
          {isLink ? (
            <Button
              color="primary"
              size="lg"
              onClick={() => {
                openAddUrlModal({
                  className: 'modal-add-url',
                  handleAddUrl: this.handleAddUrl,
                });
              }}
              disabled={saving || cancelling}
              style={{ visibility: this.isLinkEditMode() ? 'hidden' : 'visible' }}
            >
              <i className="far fa-plus" />
              {intl.formatMessage({ defaultMessage: 'Add Link Card' })}
            </Button>
          ) : (
            <>
              <Input
                type="file"
                multiple={true}
                name="file"
                className="upload-file"
                onChange={this.submitFiles}
                innerRef={this.fileInput}
                accept={getSetting('allowed_extensions').map(e => (`.${e}`)).join(',')}
              />
              <Button
                color="primary"
                size="lg"
                onClick={this.triggerInputFile}
                disabled={saving || cancelling}
                style={{ visibility: isEdit ? 'hidden' : 'visible' }}
              >
                <i className="far fa-plus" />
                {intl.formatMessage({ defaultMessage: 'Add files' })}
              </Button>
            </>
          )}
          <div className="buttons-group">
            {(
              !isEdit &&
              !isLink &&
              !cancelling &&
              submittedFiles.length !== uploadedFiles.length
            ) && (
              <FormGroup check className="save-after-upload">
                <Label for="saveAfterUpload" className="switch">
                  <div className="switch-details">
                    <span>{intl.formatMessage({ defaultMessage: 'Save and close after upload' })}</span>{' '}
                  </div>
                  <div className="switch-control input-inner">
                    <Input
                      type="checkbox"
                      id="saveAfterUpload"
                      className="input-check check-s form-check-input no-margin"
                      value="1"
                      disabled={saving || cancelling}
                      onClick={this.handleSaveAfterUploadChange}
                    />
                    <i />
                  </div>
                </Label>
              </FormGroup>
            )}
            {!(saving || cancelling) && (
              <Button
                className="cancel-upload"
                color="secondary"
                size="lg"
                onClick={this.toggleNested}
                disabled={saving || cancelling}
              >
                {intl.formatMessage({ defaultMessage: 'Cancel' })}
              </Button>
            )}
            <Modal
              isOpen={nestedModal}
              toggle={this.toggleNested}
              onClosed={closeAll ? this.toggle : undefined}
            >
              <ModalHeader>
                {intl.formatMessage({ defaultMessage: 'Cancel' })} {isLink ? '' :
                  intl.formatMessage({ defaultMessage: 'Upload' })}
              </ModalHeader>
              {(isEdit || isLink) ? (
                <ModalBody>
                  {intl.formatMessage({ defaultMessage: 'Are you sure you want to cancel? All your edits will be lost.' })}
                </ModalBody>
              ) : (
                <ModalBody>
                  {intl.formatMessage({ defaultMessage: 'Are you sure you want to cancel? All files will be deleted.' })}
                </ModalBody>
              )}
              <ModalFooter>
                <Button color="primary" onClick={this.toggleNested}>
                  {intl.formatMessage({ defaultMessage: 'No' })}
                </Button>
                {' '}
                <Button color="secondary" onClick={this.handleCancelFiles}>
                  {intl.formatMessage({ defaultMessage: 'Yes' })}
                </Button>
              </ModalFooter>
            </Modal>
            {' '}
            <Button
              color="primary"
              size="lg"
              onClick={this.handleSave}
              disabled={submittedFiles.length !== uploadedFiles.length || saving || cancelling}
            >
              {(saving || cancelling) && (
                <ProcessingSpinner />
              )}
              {this.saveButtonText()}
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.Auth.profile,
  taxonomies: state.Metadata.taxonomies,
  metadataGroups: state.Metadata.metadataGroups,
  customFields: state.Metadata.customFields,
  uploadModal: state.Files.uploadModal,
  modalMode: state.Files.uploadModalMode,
  selectedFile: state.Files.selectedFile,
  selectedFiles: state.Files.selectedFiles,
  fileStatuses: state.Files.statuses,
});

const mapDispatchToProps = dispatch => ({
  closeUploadModal: () => {
    dispatch(hideUploadModal());
    dispatch(unsetSelectedFile());
  },
  reloadFiles: (orderby = null) => {
    dispatch(refreshFiles(orderby));
  },
  reloadCollection: (collectionId) => {
    dispatch(fetchCollection(collectionId));
  },
  reloadCollections: () => {
    dispatch(refreshCollections());
  },
  resetFilesParams: () => {
    dispatch(setFilesParams({ page: 0 }));
  },
  updateFileAction: file => (
    dispatch(updateFile(file))
  ),
  openConfirmationModal: (params) => {
    dispatch(showConfirmationModal(params));
  },
  loadCurrentUsage: () => (
    dispatch(fetchClientUsage())
  ),
  openAddUrlModal: (params) => {
    dispatch(showModal('AddUrlModal', params));
  },
});

UploadModal.propTypes = {
  intl: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  taxonomies: PropTypes.array.isRequired,
  metadataGroups: PropTypes.array.isRequired,
  customFields: PropTypes.array.isRequired,
  selectedFile: PropTypes.object,
  selectedFiles: PropTypes.array.isRequired,
  fileStatuses: PropTypes.array.isRequired,
  uploadModal: PropTypes.bool.isRequired,
  modalMode: PropTypes.string.isRequired,
  closeUploadModal: PropTypes.func.isRequired,
  reloadFiles: PropTypes.func.isRequired,
  reloadCollection: PropTypes.func.isRequired,
  reloadCollections: PropTypes.func.isRequired,
  resetFilesParams: PropTypes.func.isRequired,
  updateFileAction: PropTypes.func.isRequired,
  openConfirmationModal: PropTypes.func.isRequired,
  loadCurrentUsage: PropTypes.func.isRequired,
  openAddUrlModal: PropTypes.func.isRequired,
  files: PropTypes.array,
  filesModificationTimestamp: PropTypes.instanceOf(Date),
  connectDropTarget: PropTypes.func.isRequired,
  isOver: PropTypes.bool.isRequired,
  uploader: PropTypes.object,
  submittedFiles: PropTypes.array.isRequired,
  setSubmittedFiles: PropTypes.func.isRequired,
  hasFolder: PropTypes.bool.isRequired,
  uploadCompleted: PropTypes.bool.isRequired,
  resetUploader: PropTypes.func.isRequired,
  handleRetryFile: PropTypes.func.isRequired,
};

UploadModal.defaultProps = {
  selectedFile: null,
  files: null,
  filesModificationTimestamp: null,
  uploader: null,
};

export default flow(DropTarget(NativeTypes.FILE, uploadFilesTarget, (DNDconnect, monitor) => ({
  connectDropTarget: DNDconnect.dropTarget(),
  isOver: monitor.isOver({ shallow: false }),
})), connect())(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withUploader(injectIntl(UploadModal))),
  ),
);
